import React, { useEffect } from 'react'
import { number, string, shape, func } from 'prop-types'

import useContact from '@hooks/useContact'
import useMagicLink from '@hooks/useMagicLink'
import useSimulationPermission from '@hooks/useSimulationPermission'
import useConfirmEmail from '@hooks/useConfirmEmail'
import useCalculateDiscount from '@hooks/useCalculateDiscount'

import { openChat } from '@client/utils/chatbot'

import Tail from '@components/Tail'
import * as Sections from './sections'

export default function CommercialOffer({
  step,
  path,
  actions,
  onNext,
  onPrevious,
}) {
  const { hasMagicLink } = useMagicLink()
  if (!hasMagicLink) {
    useSimulationPermission()
  }

  const { setFunnelStage } = actions
  const { contact } = useContact()

  useConfirmEmail(contact)

  useCalculateDiscount(contact, setFunnelStage, 'commercial_offer')

  useEffect(() => {
    openChat(30000)
  }, [contact.employeesNumber])

  function goToNextRoute() {
    if (onNext) {
      onNext()
    }
  }

  return (
    <>
      <Sections.Appbar />
      <Sections.CompanyInvestment
        step={step}
        path={path}
        actions={actions}
        onNext={goToNextRoute}
        contact={contact}
      />
      <Sections.EmployeeInvestment />
      <Sections.Launching />
      <Sections.FrequentlyQuestions
        step={step}
        path={path}
        actions={actions}
        onNext={goToNextRoute}
        onPrevious={onPrevious}
        contact={contact}
      />
      <Tail email={contact.email} mobilePhone={contact.mobilePhone} />
      <Sections.Footer />
    </>
  )
}

CommercialOffer.propTypes = {
  path: string.isRequired,
  actions: shape({
    setFunnelStage: func,
    setDataLayer: func,
  }).isRequired,
  step: number.isRequired,
  onNext: func,
  onPrevious: func,
}

CommercialOffer.defaultProps = {
  onNext: undefined,
  onPrevious: undefined,
}
